import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  contentColumn: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 4px 16px 16px;
  `,
  flyerDetailsInfo: css`
    padding: 0px 16px 8px 16px;
    display: flex;
    flex-direction: column;
  `,
  container: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    padding: 0px 16px 0px 16px;
  `,
  subHeader: css`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 4px 0px 8px;
  `,
};

export default styles;
